import filterCategory from './filter-category';
import returnCategories from './return-categories';
import bgImage from './bg-image';
import getKey from './get-key';
import photoArray from './photo-array';
import instagramFormat from './instagram-format';
import dropFirstItem from './drop-first-item';
import arrayPosition from './array-postion';
import upperCase from './upper-case';
import truncateText from './truncate-text';
import returnOpacity from './return-opacity';
import { splitString, removeHidden } from './filter-scripts';
import scrollWatcher from './scrollWatcher';

export {
  filterCategory,
  returnCategories,
  bgImage,
  getKey,
  photoArray,
  instagramFormat,
  dropFirstItem,
  arrayPosition,
  upperCase,
  truncateText,
  returnOpacity,
  splitString,
  removeHidden,
  scrollWatcher
};



// WEBPACK FOOTER //
// ./src/scripts/index.js